import { Typography as e } from "../../Typography/Typography.mjs";
import { Button as t } from "../Button/Button.mjs";
import { Modal as n, ModalBody as r, ModalClose as i, ModalContent as a, ModalFooter as o, ModalHeader as s, ModalTitle as c } from "../Modal/Modal.mjs";
import { useCallback as l } from "react";
import { useTranslation as u } from "@maat/store-i18n";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
//#region src/components/ConfirmModal/ConfirmModal.tsx
var p = ({ open: p, onOpenChange: m, title: h, description: g, confirmText: _, cancelText: v, variant: y = "default", onConfirm: b, onCancel: x, isLoading: S = !1 }) => {
	let { t: C } = u("common"), w = l(() => {
		x?.(), m(!1);
	}, [x, m]);
	return /* @__PURE__ */ d(n, {
		open: p,
		onOpenChange: l((e) => {
			e || x?.(), m(e);
		}, [x, m]),
		children: /* @__PURE__ */ f(a, {
			size: "sm",
			children: [
				/* @__PURE__ */ f(s, { children: [/* @__PURE__ */ d(c, { children: h }), /* @__PURE__ */ d(i, {})] }),
				g && /* @__PURE__ */ d(r, { children: /* @__PURE__ */ d(e, {
					variant: "body",
					color: "secondary",
					children: g
				}) }),
				/* @__PURE__ */ f(o, { children: [/* @__PURE__ */ d(t, {
					variant: "ghost",
					onClick: w,
					disabled: S,
					children: v ?? C("common:actions.cancel")
				}), /* @__PURE__ */ d(t, {
					variant: y === "destructive" ? "destructive" : "primary",
					onClick: b,
					disabled: S,
					isLoading: S,
					children: _ ?? C("common:actions.confirm")
				})] })
			]
		})
	});
};
//#endregion
export { p as ConfirmModal };
